module.exports = __webpack_public_path__ + "static/img/图片6.a0fc535e.png";